import PropTypes from 'prop-types'
import React from 'react'
import { TagBox } from '../../molecules/TagBox'
import { Button } from '../../atoms/Button'
import useUser, { urlFetch } from '../../../hooks/useUser'
import useMutation from '../../../hooks/useMutation'
import { urlToJson } from '../../../utils/helpers'
import { isPresentInGobPe } from '../../../configs/usersConfig'

const emailVerificationText = {
  true: { label: 'Verificado', tagType: 'success', changeText: 'Desactivar validación' },
  false: { label: 'No verificado', tagType: 'neutral', changeText: 'Activar validación' }
}

const UserEmailVerification = ({ user }) => {
  const isVerified = !!user.confirmed_at
  const status = emailVerificationText[isVerified]
  const { toggleEmailVerification, invalidateUsers } = useUser()
  return (
    <div className="flex flex-col items-start gap-1">
      <TagBox className="text-xs" label={status.label} tagType={status.tagType} />
    </div>
  )
}

UserEmailVerification.propTypes = {
  user: PropTypes.object
}

export default UserEmailVerification
